import React from "react";
import OperatorsList from "ComponentsUI/OperatorsList";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { graphql } from "@apollo/client/react/hoc";
import { OPERATORS_QUERY } from "Services/queries";
import withDefaultParams from "Services/withDefaultParams";
import PaginationContainer from "../Containers/PaginationContainer";
import orderBy from "lodash/orderBy";
import { generateUrl } from "Services/withDefaultParams";
import { PaddingBottom } from "ComponentsUI/Spacings";
import queryString from "query-string";
import { Redirect404, RedirectPagination } from "ComponentsUI/Redirects";
import { Helmet } from "react-helmet-async";
import configRouters from "Configs/routes";
import { LimitOperatorsList } from "Constants/Limit";
import { StubOperatorsList } from "ComponentsUI/Stub";
import { isMainSiteCode } from "Utils/siteConfig";

@inject("ApplicationModel")
@observer
class Page extends React.Component {
	static defaultProps = {
		onOperatorSelect: () => {},
		onOperatorConnect: () => {},
		onOperatorReviews: () => {},
	};

	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = generateUrl(configRouters.Operatory.route, this.props.match.params);

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	// Закрыть модальное окно, если оно открыто во время перехода на данную страницу
	componentDidMount() {
		const modal = this.props.ApplicationModel.modalModel;
		if (modal.isOpen) {
			modal.toggleModal();
		}
	}

	render() {
		if (this.props.data.loading && !this.props.data.operators)
			return <StubOperatorsList amount={LimitOperatorsList} amountVip={1} />;
		let page = 1;
		if (this.props.match.params.page > -1) {
			page = parseInt(this.props.match.params.page);
		}

		if (this.props.match.params.page === "1") {
			return <RedirectPagination />;
		}

		if (
			!page ||
			this.props.data?.operators?.pagination?.items_total < LimitOperatorsList * (page - 1)
		) {
			return <Redirect404 message404={"Выбрана пагинация больше доступной у списка операторов"} />;
		}

		let {
			ApplicationModel: { windowSizeModel, ratesModel, text },
			data: {
				operators: { data, pagination },
				operatorsAggregate: { aggregation } = {},
			},
		} = this.props;
		const siteCode = this.props.ApplicationModel.siteCode;

		let operators = JSON.parse(JSON.stringify(data));
		const operatorsVipTariffs = operators.filter((x) => x.vip_provider && x.info.cnt_tariffs);
		const operatorsVipNoTariffs = operators.filter((x) => x.vip_provider && !x.info.cnt_tariffs);
		const operatorsNoVipTariffs = operators.filter((x) => !x.vip_provider && x.info.cnt_tariffs);
		const operatorsNoVipNoTariffs = operators.filter((x) => !x.vip_provider && !x.info.cnt_tariffs);

		operators = operatorsVipTariffs.concat(
			operatorsVipNoTariffs,
			operatorsNoVipTariffs,
			operatorsNoVipNoTariffs
		);

		let sortedAggregation = {};
		for (let it in aggregation) {
			sortedAggregation[it] = orderBy(aggregation[it], "name", "asc");
		}
		return (
			<>
				{this.canonical()}
				{isMainSiteCode(siteCode) && <div></div>}
				<div>
					<PaddingBottom>
						<OperatorsList
							{...this.props}
							withoutAdBlock={true}
							text={text}
							windowSize={windowSizeModel.windowSizes}
							items={operators}
							onOperatorConnect={this.props.onOperatorConnect}
							flat={ratesModel.orientation}
							yandexEvent={"providers.impressions_vip"}
						/>
					</PaddingBottom>
					<PaginationContainer key={3} pagination={pagination} limit={LimitOperatorsList} />
				</div>
			</>
		);
	}
}

export default withRouter(
	withDefaultParams(
		graphql(OPERATORS_QUERY, {
			skip: (ownProps) => {
				return ownProps.match.params.regionUrl ? false : true;
			},
			options: (props) => {
				let page = 1;
				if (props.match.params.page) {
					page = props.match.params.page;
				}
				let sort = "-vip_provider,vip_b2c_priority,-rating.expert.final,name";
				let filters = [];
				let aggregateFilter = [];
				let params = queryString.parse(props.location.search);

				if (params.sort) {
					sort = params.sort;
				}

				if (params.operators) {
					filters.push(`id=${params.operators}`);
				}

				if (params.service) {
					filters.push(`order_types.id=${params.service}`);
					if (!params.operators) {
						aggregateFilter.push(`order_types.id=${params.service}`);
					}
				}

				if (params.dody) {
					filters.push(`dody.global_id=${params.dody}`);
					if (!params.operators) {
						aggregateFilter.push(`dody.global_id=${params.dody}`);
					}
				}

				if (props.match.params.regionUrl) {
					filters.push(`region.url=${props.match.params.regionUrl}`);
					aggregateFilter.push(`region.url=${props.match.params.regionUrl}`);
				}

				return {
					variables: {
						filter: filters.join("&"),
						aggregateFilter: aggregateFilter.join("&"),
						limit: LimitOperatorsList,
						offset: page > 0 ? LimitOperatorsList * (page - 1) : 0,
						sort: sort,
					},
				};
			},
		})(Page)
	)
);
